import { useEffect, useState } from "react";
import { Check, ChevronsUpDown } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Command, CommandEmpty, CommandGroup, CommandInput, CommandItem, CommandList } from "@/components/ui/command";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { api } from "@/lib/api";

export function AuthoritySelect({ value, onChange, allowAll, allowNone, placeholder = "Select authority", testId = "authority-select", className = "w-full" }) {
  const [list, setList] = useState([]);
  const [open, setOpen] = useState(false);
  useEffect(() => { api.get("/authorities").then((r) => setList(r.data)).catch(() => setList([])); }, []);
  const cur = list.find((a) => a.id === value);
  const pick = (v) => { onChange(v); setOpen(false); };
  const label = cur ? `${cur.short_name} · ${cur.full_name}` : allowAll ? "All authorities" : allowNone ? "No authority" : placeholder;
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button variant="outline" role="combobox" className={`${className} justify-between font-normal`} data-testid={testId}>
          <span className={`truncate ${cur ? "" : "text-muted-foreground"}`}>{label}</span><ChevronsUpDown className="ml-2 h-4 w-4 shrink-0 opacity-50" />
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-[340px] p-0" align="start">
        <Command>
          <CommandInput placeholder="Search short or full name…" data-testid={`${testId}-search`} />
          <CommandList>
            <CommandEmpty>No authority found. Ask the V.A Admin to add it.</CommandEmpty>
            <CommandGroup>
              {(allowAll || allowNone) && <CommandItem value="__none all authorities no authority" onSelect={() => pick("")} data-testid={`${testId}-none`}>{allowAll ? "All authorities" : "No authority"}</CommandItem>}
              {list.filter((a) => a.is_active || a.id === value).map((a) => (
                <CommandItem key={a.id} value={`${a.short_name} ${a.full_name}`} onSelect={() => pick(a.id)} data-testid={`${testId}-opt-${a.short_name}`}>
                  <Check className={`mr-2 h-4 w-4 ${value === a.id ? "opacity-100" : "opacity-0"}`} />
                  <span className="font-semibold">{a.short_name}</span><span className="ml-2 truncate text-muted-foreground">{a.full_name}{a.is_active ? "" : " (inactive)"}</span>
                </CommandItem>
              ))}
            </CommandGroup>
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  );
}
